import { render } from "./Material.vue?vue&type=template&id=1b072632&scoped=true&ts=true"
import script from "./Material.vue?vue&type=script&lang=ts"
export * from "./Material.vue?vue&type=script&lang=ts"

import "./Material.vue?vue&type=style&index=0&id=1b072632&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/5c6defa0/0/anyclass/anyclass-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b072632"]])

export default __exports__